import React, { Fragment } from 'react';
import { Select } from '@lingui/macro';
import Checkbox from '@mos-cat/checkbox';
import { Dispatch } from 'redux';
import { connect } from 'dva';

import { AGREEMENTS_FIELD_NAME } from '../../../constants/fieldNames';
import { Field } from '../../../declarations/widget-ums';
import { Sex } from '../../shared/PersonGender/PersonGender';
import { getOnChange } from '../../../helpers/handlers';
import { agreementsComponentSelector } from '../../../selectors/submit';
import { AGREEMENTS } from '../../../constants/modelNames';
import './Agreements.pcss';

interface AgreementsComponentProps {
  warnedAboutResponsibility: Field<boolean>;
  consentWithTerms: Field<boolean>;
  applicantSex: Sex;
  onChange?(): void;
}

function Agreements({
  warnedAboutResponsibility,
  consentWithTerms,
  applicantSex,
  onChange,
}: AgreementsComponentProps) {
  const {
    warnedAboutResponsibility: warnedAboutResponsibilityName,
    consentWithTerms: consentWithTermsName,
  } = AGREEMENTS_FIELD_NAME;

  return (
    <div className="StepContentBlock Agreements">
      <div className="PguFormGrid__row">
        <Checkbox
          label={
            <Select
              value={applicantSex}
              other={
                <Fragment>
                  Я предупрежден(а) об ответственности, предусмотренной
                  законодательством, за предоставление неверных сведений и
                  документов. Обязуюсь в{' '}
                  <strong className="text-strong">месячный срок</strong>{' '}
                  обратиться с заявлением в орган социальной защиты населения
                  города Москвы и сообщить обо всех изменениях в семье, имеющих
                  юридическое значение для прекращения действия льготного
                  статуса (помещение детей в детские учреждения на полное
                  государственное обеспечение, перемена места жительства,
                  передача ребёнка на воспитание другому родителю, установление
                  отцовства в отношении ребёнка, оформление над ребёнком опеки
                  (попечительства), лишение родительских прав, ограничение в
                  родительских правах).
                </Fragment>
              }
              m={
                <Fragment>
                  Я предупрежден об ответственности, предусмотренной
                  законодательством, за предоставление неверных сведений и
                  документов. Обязуюсь в{' '}
                  <strong className="text-strong">месячный срок</strong>{' '}
                  обратиться с заявлением в орган социальной защиты населения
                  города Москвы и сообщить обо всех изменениях в семье, имеющих
                  юридическое значение для прекращения действия льготного
                  статуса (помещение детей в детские учреждения на полное
                  государственное обеспечение, перемена места жительства,
                  передача ребёнка на воспитание другому родителю, установление
                  отцовства в отношении ребёнка, оформление над ребёнком опеки
                  (попечительства), лишение родительских прав, ограничение в
                  родительских правах)
                </Fragment>
              }
              f={
                <Fragment>
                  Я предупреждена об ответственности, предусмотренной
                  законодательством, за предоставление неверных сведений и
                  документов. Обязуюсь в{' '}
                  <strong className="text-strong">месячный срок</strong>{' '}
                  обратиться с заявлением в орган социальной защиты населения
                  города Москвы и сообщить обо всех изменениях в семье, имеющих
                  юридическое значение для прекращения действия льготного
                  статуса (помещение детей в детские учреждения на полное
                  государственное обеспечение, перемена места жительства,
                  передача ребёнка на воспитание другому родителю, установление
                  отцовства в отношении ребёнка, оформление над ребёнком опеки
                  (попечительства), лишение родительских прав, ограничение в
                  родительских правах).
                </Fragment>
              }
            />
          }
          name={consentWithTermsName}
          {...consentWithTerms}
          onChange={onChange}
        />
      </div>
      <div className="PguFormGrid__row">
        <Checkbox
          label={
            <Select
              value={applicantSex}
              m="Ознакомлен, что информация, указанная в заявлении, будет проверена путем
              межведомственного информационного взаимодействия. В случае не
              подтверждения представленных в заявлении сведений, в Личный
              кабинет будет направлено уведомление о необходимости представления
              оригиналов документов. Донести требуемые документы можно в любой
              Центр государственных услуг города Москвы «Мои документы» (при
              себе иметь документ, удостоверяющий личность)."
              f="Ознакомлена, что информация, указанная в заявлении, будет проверена путем
              межведомственного информационного взаимодействия. В случае не
              подтверждения представленных в заявлении сведений, в Личный
              кабинет будет направлено уведомление о необходимости представления
              оригиналов документов. Донести требуемые документы можно в любой
              Центр государственных услуг города Москвы «Мои документы» (при
              себе иметь документ, удостоверяющий личность)."
              other="Ознакомлен(а), что информация, указанная в заявлении, будет проверена путем
              межведомственного информационного взаимодействия. В случае не
              подтверждения представленных в заявлении сведений, в Личный
              кабинет будет направлено уведомление о необходимости представления
              оригиналов документов. Донести требуемые документы можно в любой
              Центр государственных услуг города Москвы «Мои документы» (при
              себе иметь документ, удостоверяющий личность)."
            />
          }
          name={warnedAboutResponsibilityName}
          {...warnedAboutResponsibility}
          onChange={onChange}
        />
      </div>
    </div>
  );
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onChange: getOnChange(AGREEMENTS, dispatch),
});

export default connect(
  agreementsComponentSelector,
  mapDispatchToProps
)(Agreements);
